<template>
  <v-card class="mt-2" outlined>
    <v-container fluid>
      <v-row class="mx-3 mb-3">
        <v-col class="d-flex justify-start" cols="7">
          <h2>{{ $t('title') }}</h2>
          <v-btn class="ml-5 mt-n1 button-add" @click="addChannel">{{ $t('btnAdd') }}</v-btn>
        </v-col>
        <v-col cols="5">
          <v-text-field v-if="this.$store.state.clubChannels.length > 0" class="mt-n2" :placeholder="$t('hintSearch')" append-icon="fa-search" v-model="search" single-line hide-details/>
        </v-col>
      </v-row>
      <v-data-table v-if="this.$store.state.clubChannels.length > 0" :search="search" :items="this.$store.state.clubChannels" :headers="headers">
        <template v-slot:item.name="{ item }">
          <v-chip :color="`#${$store.state.clubMember.club.primaryColor}`" outlined class="channel-chip" small v-text="item.name"></v-chip>
        </template>
        <template v-slot:item.visibility="{ item }">
          <p class="mb-0" v-html="$t((item.visibility === 'PUBLIC')? 'table.publicDescription' : 'table.privateDescription')"/>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-chip v-if="item.visibility !== 'PUBLIC'" @click="channelContributors(item)" class="ml-2" small><p style="font-size: 13px;" class="mb-0">
            {{ $t('table.members')  }} <v-icon class="ml-1" x-small>fa-users</v-icon></p></v-chip>
          <v-chip @click="channelOptions(item)" class="ml-2" small><p style="font-size: 13px;" class="mb-0">
            {{ $t('table.options') }} <v-icon class="ml-1" x-small>fa-ellipsis-v</v-icon></p></v-chip>
        </template>
      </v-data-table>
      <h4 class="text-center my-12" v-else>{{ $t('noChannels') }}</h4>
    </v-container>

    <v-overlay v-model="overlayAddChannel">
      <AddChannel :arePublicChannelsUnavailable="arePublicChannelsUnavailable" :arePrivateChannelsUnavailable="arePrivateChannelsUnavailable"
        @closeWindow="overlayAddChannel = false"/>
    </v-overlay>
    <v-overlay v-model="overlayChannelContributors">
      <ChannelContributors :channel="currentChannel" @closeWindow="overlayChannelContributors = false"/>
    </v-overlay>
    <v-overlay v-model="overlayChannelOptions">
      <ChannelOptions :channel="currentChannel" @closeWindow="overlayChannelOptions = false"/>
    </v-overlay>

    <v-overlay v-model="overlayUnavailableFeatures">
      <UnavailableFeature :hasCloseWindowAction="true" @closeWindow="overlayUnavailableFeatures = false"/>
    </v-overlay>
  </v-card>
</template>

<script>
import Repository from '../../../repositories/club';
import { mapMutations } from 'vuex';
import AddChannel from "@/views/Community/components/AddChannel";
import ChannelOptions from "@/views/Community/components/ChannelOptions";
import ChannelContributors from "@/views/Community/components/ChannelContributors";
import UnavailableFeature from './UnavailableFeature';

export default {
  name: "ClubChannels",
  components: {ChannelContributors, ChannelOptions, AddChannel, UnavailableFeature},
  data() {
    return {
      arePublicChannelsUnavailable: true,
      arePrivateChannelsUnavailable: true,
      overlayUnavailableFeatures: false,
      overlayAddChannel: false,
      overlayChannelContributors: false,
      overlayChannelOptions: false,
      currentChannel: null,
      search: '',
      headers: [
        { text: this.$t('table.name'), align: 'left', value: 'name', sortable: true, filterable: true, },
        { text: this.$t('table.visibility'), align: 'left', value: 'visibility', sortable: true, filterable: false, },
        { text: this.$t('table.actions'), align: 'right', value: 'actions', sortable: false, filterable: false, },
      ]
    };
  },
  mounted() {
    if(!(this.$store.state.clubMember.rol === 'FOUNDER' || this.$store.state.clubMember.rol === 'ADMIN'))
      this.$router.push('/club');
    else
      this.init();
  },
  methods: {
    ...mapMutations(['setClubChannels']),
    init() {
      Repository.getAllClubChannels(this.$store.state.clubMember.club.id).then((response) => {
        if(response.status < 400)
          this.setClubChannels(response.data);
      });
      this.validateFeaturesAvailable();
    },
    validateFeaturesAvailable() {
      let permissions = this.$store.state.clubPermissions;
      for(let permission of permissions) {
        if(permission.clubFeature.name == 'PUBLIC_CHANNELS') {
          this.arePublicChannelsUnavailable = false;
        } else if(permission.clubFeature.name == 'PRIVATE_CHANNELS') {
          this.arePrivateChannelsUnavailable = false;
        }
      }
    },
    addChannel() {
      if(this.arePublicChannelsUnavailable && this.arePrivateChannelsUnavailable) {
        this.overlayUnavailableFeatures = true;
      } else {
        this.overlayAddChannel = true;
      }
    },
    channelContributors(channel) {
      this.currentChannel = channel;
      this.overlayChannelContributors = true;
    },
    channelOptions(channel) {
      this.currentChannel = channel;
      this.overlayChannelOptions = true;
    },
  }
}
</script>

<i18n>
{
  "en": {
    "title": "Community Channels",
    "btnAdd": "Create Channel",
    "hintSearch": "Search for channels...",
    "table": {
      "name": "Channel Name",
      "visibility": "Channel Visibility",
      "actions": "Channel Actions",
      "publicDescription": "Public Channel",
      "privateDescription": "Private Channel",
      "members": "Members",
      "options": "Options"
    },
    "noChannels": "There are no channels. Only General channel."
  },
  "es": {
    "title": "Canales de Comunidad",
    "btnAdd": "Crear Canal",
    "hintSearch": "Buscar por canales...",
    "table": {
      "name": "Nombre del Canal",
      "visibility": "Visibilidad del Canal",
      "actions": "Acciones del Canal",
      "publicDescription": "Canal Público",
      "privateDescription": "Canal Privado",
      "members": "Miembros",
      "options": "Opciones"
    },
    "noChannels": "No hay canales actualmente. Únicamente el canal General."
  }
}
</i18n>

<style scoped>
  .button-add {
    background-color: #111111 !important;
    color: #ffffff !important;
    border: #111111 solid 1px;
  }

  .channel-chip {
    font-size: 14px !important;
    color: #111111 !important;
  }
</style>
